import React, { useState } from "react";
import PropTypes from "prop-types";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";
import FormField from "./FormField";

function FormAsync(props) {
  const [values, setValues] = useState(null);

  const fieldProps = ({ value, onChange }) => ({
    async: props.async,
    onChange: (e, value) => {
      if (props.multiple) {
        setValues(value);
        let parsed = JSON.stringify(value.map((obj) => obj.value));
        onChange({ target: { value: parsed } }, parsed);
      } else {
        onChange({ target: { value: value?.value ?? "" } }, value?.value ?? "");
      }
    },
    value:
      (props.multiple ? values : typeof value == "object" || typeof value == "undefined" ? value : { value }) ??
      (value ? JSON.parse(value).map((id) => ({ value: id })) : props.multiple ? [] : null),
    multiple: props.multiple,
    nullable: props.nullable,
    freeSolo: props.freeSolo,
    primaryKey: props.primaryKey,
    ...props.fieldProps,
  });
  return <FormField {...props} Field={AsynchronousAutocomplete} fieldProps={fieldProps} />;
}

FormAsync.defaultProps = {
  multiple: false,
  nullable: false,
  freeSolo: false,
  fieldProps: {},
};

FormAsync.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  async: PropTypes.object.isRequired,
  multiple: PropTypes.bool,
  freeSolo: PropTypes.bool,
};

export default FormAsync;
